import React from 'react';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { PermissionCard } from '../cards';

export interface AdminSubSettingItem {
  id: string;
  label: string;
  description: string;
  value: boolean;
  setter: (value: boolean) => void;
}

export interface AdministrationSubSettingsProps {
  items: AdminSubSettingItem[];
  disabled: boolean;
  onChange: (item: AdminSubSettingItem, value: boolean) => void;
}

export const AdministrationSubSettings: React.FC<AdministrationSubSettingsProps> = ({ items, disabled, onChange }) => (
  <>
    {items.map((item) => (
      <TooltipProvider key={item.id}>
        <Tooltip>
          <TooltipTrigger asChild>
            <div className="h-full">
              <PermissionCard
                label={<Label htmlFor={item.id} className={disabled ? 'cursor-not-allowed text-muted-foreground' : 'cursor-pointer'}>{item.label}</Label>}
                description={item.description}
                dimmed={disabled}
                control={
                  <Checkbox
                    id={item.id}
                    checked={item.value}
                    disabled={disabled}
                    onCheckedChange={(c) => onChange(item, c as boolean)}
                  />
                }
              />
            </div>
          </TooltipTrigger>
          {disabled && <TooltipContent><p>Requires 'Configure' access to General Settings</p></TooltipContent>}
        </Tooltip>
      </TooltipProvider>
    ))}
  </>
);
